<h1 mat-dialog-title>Interactive Menu</h1>
<div mat-dialog-content>
  <mat-tab-group>
    <!--<mat-tab label="Bookmarks">
      <br />
      <table style="width: 100%">
        <tr>
          <td style="width: 20%; vertical-align: top; font-size: 14px">Select Bookmark:</td>
          <td style="vertical-align: middle;">
            <mat-select name="selectedBookmark" style="width: 100%" [(ngModel)]="data.selectedBookmark">
              <mat-option *ngFor="let bookmark of data.interactBookmarks" [value]=bookmark>{{bookmark.name}} {{bookmark.createdBy ? '[' + bookmark.createdBy + ']' : ''}}</mat-option>
            </mat-select><br /><br />
          </td>
        </tr>
        <ng-container *ngIf="data.selectedBookmark !== null && data.selectedBookmark.bookmarkId !== 0">
          <tr><td colspan="2"><button style="width: 100%" mat-raised-button class="piButton" (click)="applyBookmark()">Go To Bookmark</button></td></tr>
        </ng-container>
        <ng-container *ngIf="data.selectedBookmark !== null && data.selectedBookmark.bookmarkId !== 0 && data.selectedBookmark.canModify">
          <tr><td colspan="2"><button style="width: 100%" mat-raised-button class="piButton" (click)="editBookmark()">Save Bookmark</button></td></tr>
        </ng-container>
        <ng-container *ngIf="data.selectedBookmark !== null && data.selectedBookmark.bookmarkId !== 0 && data.selectedBookmark.canModify">
          <tr><td colspan="2"><button style="width: 100%" mat-raised-button class="piButton" (click)="createBookmark()">Save Bookmark As</button></td></tr>
        </ng-container>
        <ng-container *ngIf="data.selectedBookmark === null || data.selectedBookmark.bookmarkId === 0">
          <tr><td colspan="2"><button style="width: 100%" mat-raised-button class="piButton" (click)="createBookmark()">Create Bookmark</button></td></tr>
        </ng-container>
        <ng-container *ngIf="data.selectedBookmark !== null && data.selectedBookmark.bookmarkId !== 0 && data.selectedBookmark.canModify">
          <tr><td colspan="2"><button style="width: 100%" mat-raised-button class="piButton" (click)="deleteBookmark()">Delete Bookmark</button></td></tr>
        </ng-container>
      </table>
    </mat-tab>-->
    <mat-tab label="Interactive" *ngIf="data.modInteractve">
      <br />
      <table style="width: 100%">
        <ng-container *ngIf="data.modInteractve">
          <tr>
            <td colspan="2">
              <button
                style="width: 100%"
                mat-raised-button
                class="piButton"
                (click)="save()"
              >
                Save Interactive
              </button>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <button
                style="width: 100%"
                mat-raised-button
                class="piButton"
                (click)="saveAs()"
              >
                Save Interactive As
              </button>
            </td>
          </tr>
          <tr *ngIf="data.isOwner">
            <td colspan="2">
              <button
                style="width: 100%"
                mat-raised-button
                class="piButton"
                (click)="updateSharing()"
              >
                Update Interactive Sharing
              </button>
            </td>
          </tr>
        </ng-container>
      </table>
    </mat-tab>
    <!--<mat-tab label="Filters">
      <br />
      <table style="width: 100%">
        <tr><td colspan="2">Current Filter: <b>{{data.appliedFilter.name}} {{data.appliedFilter.createdBy ? '[' + data.appliedFilter.createdBy + ']' : ''}}</b><br /><br /></td></tr>
        <tr>
          <td style="width: 20%; vertical-align: top; font-size: 14px">Select Filter:</td>
          <td style="vertical-align: middle;">
            <mat-select name="selectedFilter" style="width: 100%" [(ngModel)]="data.selectedFilter">
              <mat-option *ngFor="let filter of data.interactFilters" [value]=filter>{{filter.name}} {{filter.createdBy ? '[' + filter.createdBy + ']' : ''}}</mat-option>
            </mat-select><br /><br />
          </td>
        </tr>
        <tr><td colspan="2"><button style="width: 100%" mat-raised-button class="piButton" (click)="applyFilter()">Load Filter</button></td></tr>
        <ng-container *ngIf="data.appliedFilter.canModify">
          <tr><td colspan="2"><button style="width: 100%" mat-raised-button class="piButton" (click)="editFilter()">Save Filter</button></td></tr>
        </ng-container>
        <tr><td colspan="2"><button style="width: 100%" mat-raised-button class="piButton" (click)="createFilter()">Save Filter As</button></td></tr>
        <ng-container *ngIf="data.appliedFilter.canModify">
          <tr><td colspan="2"><button style="width: 100%" mat-raised-button class="piButton" (click)="deleteFilter()">Delete Filter</button></td></tr>
        </ng-container>
      </table>
    </mat-tab>-->
  </mat-tab-group>
</div>
